import React, { Component } from 'react';
import { connect } from 'react-redux';
import './NewProject.css';
import checkCirclePng from 'images/check-circle.png';
import { getNewProjectId } from 'components/admin/projects/creation/store/selectors';
import { goToProjectDetails } from 'components/admin/projects/store/actions';

class Success extends Component {
  handleContinue = () => {
    this.props.dispatch(goToProjectDetails(this.props.newProjectId));
  };

  render() {
    return (
      <div className="project-success">
        <div className="project-success-content">
          <img src={checkCirclePng} className="success-check" alt="Success" />

          <h2>Project Created</h2>

          <div className="success-message">
            Begin adding all other details to create your proposal.
          </div>

          <input
            className="btn button button-continue button-orange"
            type="button"
            value="Continue"
            onClick={this.handleContinue}
          />
        </div>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    newProjectId: getNewProjectId(state),
  };
})(Success);



// WEBPACK FOOTER //
// ./src/components/admin/projects/creation/Success.js